import instance from '../axios';

export const togleUserStatus = (userId) => {
  return instance.put(`/users/${userId}/togleStatus`);
};


export const getUserQueries = () => {
  return instance.get('/users/monthlyQueries');
}